import React, {Component} from 'react'
import {
  Link
} from 'react-router-dom';
import Content from '../Content'

import moment from 'moment';

class EventsList extends Component {

  getDate = (dateStr) => {
    return moment(dateStr).format('ddd M.D');
  }

  getCompareDate = (dateStr) => {
    return moment(dateStr).format('YMD');
  }

  render () {

    const events = this.props.events.map((e) => {

      return (

                <div className="Template-section Template-section--narrow">
                  <div className="Template-heading">
                    <Content modifier={'alt'}>
                    <h1>{this.getDate(e.startDate.date)}</h1>
                    </Content>
                </div>
                <div className="Template-content">

                    <h3><Link to={e.uri}>{e.title}</Link></h3>


                    <Content html={e.title}/>

                </div>
                </div>
      )
    } );


    return (
      <div className={'EventsList'}>
        {events}
      </div>
    )
  }
}

export default EventsList



// WEBPACK FOOTER //
// ./src/js/components/EventsList/EventsList.jsx